export enum Step {
  DATA = 'DATA',
  PASSWORD = 'PASSWORD',
}
